import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { PopUp } from '@components/PopUp'
import { SwitchButton } from '@components/SwitchButton'

import { Col, Container, SubTitle, SwitchContainer, SwitchLabel, Title } from './PopUpExportPlanning.styled'

export interface ExportOptions {
  showCover: boolean
}

interface Props {
  onSubmit: (options: ExportOptions) => void
  onClose: () => void
}

export const PopUpExportPlanning = (props: Props): JSX.Element => {
  const { onClose, onSubmit } = props

  const [exportConfig, setExportConfig] = useState<ExportOptions>({
    showCover: true,
  })

  const { t } = useTranslation()

  const handleShowCover = () => {
    setExportConfig((prev) => ({ ...prev, showCover: !prev.showCover }))
  }

  return (
    <PopUp
      title={t('modules_project-plannings_components_PopUpExportPlanning_title')}
      onSubmitLabel={t('modules_project-observations_components_PopUpExportObservations_submit_label')}
      onClose={onClose}
      onSubmit={() => onSubmit(exportConfig)}
    >
      <Container>
        <Col>
          <Title>{t('modules_project-observations_components_PopUpExportObservations_cover_title')}</Title>
          <SubTitle>{t('modules_project-observations_components_PopUpExportObservations_cover_subtitle')}</SubTitle>
          <SwitchContainer>
            <SwitchButton selected={exportConfig.showCover} onClick={handleShowCover} />
            <SwitchLabel>{t('modules_project-observations_components_PopUpExportObservations_enabled')}</SwitchLabel>
          </SwitchContainer>
        </Col>
      </Container>
    </PopUp>
  )
}
